import React from 'react';
import { InterPoint } from '@saviynt/common';

import './Title.css';

function LabelValueForTitle({ label, value }) {
  return (
    <span className='ListRow-labelValue'>
      <span className='ListRow-labelValue-label'>
        {label}
:
      </span>

      <span className='ListRow-labelValue-text'>{value}</span>
    </span>
  );
}

function Title({ data }) {
  const dataArray = Array.isArray(data) ? data : [data];

  return (
    <div className='ListRow-title'>
      {dataArray.map((item, index) => (
        <div className='ListRow-title-content' key={item.text || item.label}>
          {index > 0 && (
            <div className='ListRow-separator'>
              <InterPoint font='body3' />
            </div>
          )}
          {item.kind === 'label-value' && (
            <LabelValueForTitle label={item.label} value={item.value} />
          )}
          {item.kind === 'text' && item.text}
        </div>
      ))}
    </div>
  );
}

export default Title;
